(() => {
  if (customElements.get('mmlc-product-shelf')) return;
  customElements.define('mmlc-product-shelf', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.studio-rec__track');
      this.controls = this.querySelector('.studio-rec__controls');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = end < 2;
        this.controls.querySelector('[data-step="-1"]').disabled = this.track.scrollLeft <= 2;
        this.controls.querySelector('[data-step="1"]').disabled = this.track.scrollLeft >= end - 2;
      };
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        const firstCard = this.track.querySelector('.studio-rec__item');
        const cardWidth = firstCard?.getBoundingClientRect().width || this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = (cardWidth + gap) * Math.max(1, Math.floor(this.track.clientWidth / (cardWidth + gap)));
        this.track.scrollTo({ left: this.track.scrollLeft + Number(button.dataset.step) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.update();
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
})();

